import { Facebook, Instagram, Twitter, Youtube, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { t } from "../../utils/translate";
import { useSelector } from "react-redux";

export function FooterBase() {

    const currentLanguage = useSelector(
      (state) => state?.global?.current_language
    );

    
  return (
    <footer className="relative bg-[#0072bb] text-white pt-20 pb-6 mt-20">
      {/* <div className="absolute top-0 left-0 right-0  bg-[#0072bb]">
        <div className="absolute -top-16 left-0 right-0 h-16 bg-[#0072bb] rounded-t-[50px]" />
      </div> */}
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-5  gap-8 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-4">Salus Scaffold</h3>
            <p className="text-white mb-6">
              {t("social_network")}
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/people/Salus-Scaffold/61560883563967/"
                blank="_"
              >
                <Facebook className="w-5 h-5 text-white hover:text-gray-200  cursor-pointer" />
              </a>
              <a
                href="https://www.linkedin.com/company/salus-scaffold/"
                blank="_"
              >
                <Linkedin className="w-5 h-5 text-white hover:text-gray-200  cursor-pointer" />
              </a>

              <Instagram className="w-5 h-5 text-white hover:text-gray-200  cursor-pointer" />
              {/* <Twitter className="w-5 h-5 text-white hover:text-gray-200  cursor-pointer" />
              <Youtube className="w-5 h-5 text-white:text-white hover:text-gray-200 cursor-pointer" /> */}
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t("our_district")}</h4>
            <ul className="space-y-2 text-white ">
              <li className="hover:text-gray-200">
                <Link to="/about-us">{t("about_us")}</Link>
              </li>

              <li className="hover:text-gray-200">
                <Link to="/services">{t("user_guide")}</Link>
              </li>

              <li className="hover:text-gray-200">
                <Link to="/contact-us">{t("contact_us")}</Link>
              </li>

              <li className="hover:text-gray-200">
                <Link to="/about-us">{t("demo_account")}</Link>
              </li>

              <li className="hover:text-gray-200">
                <Link to="/subscription">{t("subscription")}</Link>
              </li>
            </ul>
          </div>

          {/* <div>
            <h4 className="font-semibold mb-4">Construction</h4>
            <ul className="space-y-2 text-white ">
              <li className="hover:text-gray-200">Flex</li>
              <li className="hover:text-gray-200">Full Time</li>
              <li className="hover:text-gray-200">Global</li>
            </ul>
          </div> */}

          <div>
            <h4 className="font-semibold mb-4">{t("company")}</h4>
            <ul className="space-y-2 text-white ">
              <li className="hover:text-gray-200">
                <Link to="/about-us">{t("about")}</Link>
              </li>
              <li className="hover:text-gray-200">
                <Link to="/about-us">{t("faq")}</Link>
              </li>
              <li className="hover:text-gray-200">
                <Link to="/contact-us">{t("contact_us")}</Link>
              </li>
              <li className="hover:text-gray-200">
                <Link to="/services">{t("services_footer")}</Link>
              </li>
              <li className="hover:text-gray-200">
                <Link to="/support">{t("support_footer")}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-4 text-sm text-white ">
            <Link to="#" className="hover:text-gray-200 text-white">
            {t("privacy_Policy")}
            </Link>
            <Link
              to="/terms-and-conditions-summary"
              className="hover:text-gray-200 text-white"
            >
              {t("terms_and_condition")}
            </Link>
            <Link to="#" className="hover:text-gray-200 text-white">
              {t("cookies_policy")}
            </Link>
          </div>
          <div className="text-sm text-white hover:text-gray-400">
            © 2025 Salus Scaffold. {t("all_right_reserve")}
          </div>
          <div className="flex gap-4 text-sm text-gray-400">
            <button className="hover:text-gray-400 text-white">English</button>
            <button className="hover:text-gray-400 text-white">
              Norwegian
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
